import mobile_util from "./mobile_util"

function isEmbed() {
  return window.config && window.config.hosted_in === "embed"
}

function fireOrientationEvent() {
  let orientation, deviceType
  if (screen.width >= 768) {
    deviceType = "Tablet"
  } else {
    deviceType = "Phone"
  }

  if (window.orientation == 90 || window.orientation == -90) {
    //Landscape
    orientation = "Landscape"
  } else {
    orientation = "Portrait"
  }
  window._gaq.push(["_trackEvent", "MobileApp", "orientation" + orientation + deviceType])
}

let isEuLocale = function (locales) {
  // top tier EU locales. If we see any of these, we must show the banner
  locales = locales.map(function (locale) {
    return locale.toLowerCase()
  })
  let euTier1 = ["en-gb", "pt-pt", "de", "de-de", "fr", "fr-fr", "it", "it-it", "nl", "nl-nl", "es", "es-es"]
  for (let i = 0; i < locales.length; i++) {
    let locale = locales[i]
    if (euTier1.indexOf(locale) != -1) {
      return true
    }
  }
  if (locales.indexOf("pt") != -1 && locales.indexOf("pt-br") == -1) {
    return true
  } else if (locales.indexOf("en") != -1 && locales.indexOf("en-us") == -1) {
    return true
  } else {
    return false
  }
}

$(window).load(function () {
  if (isEmbed()) {
    return
  }

  _gaq.push(["_setAccount", "UA-2330466-1"])
  _gaq.push(["_setDomainName", ".slideshare.net"])
  _gaq.push(["_addIgnoredRef", "slideshare.net"])
  _gaq.push(["_trackPageview"])

  let ga = document.createElement("script")
  ga.type = "text/javascript"
  ga.async = true
  ga.src = ("https:" == document.location.protocol ? "https://ssl" : "http://www") + ".google-analytics.com/ga.js"
  let s = document.getElementsByTagName("script")[0]
  s.parentNode.insertBefore(ga, s)
  fireOrientationEvent()
  let viewOrientation = window.orientation === 0 || window.orientation === undefined ? "_portrait" : "_landscape"

  // TOS Update Banner
  let langs
  if (navigator.languages) {
    langs = navigator.languages
  } else {
    if (navigator.language) {
      langs = [navigator.language]
    } else {
      langs = []
    }
  }
})

export function isIos() {
  let ios = navigator.userAgent.match(/(iPhone|iPad|iPod)/i)
  return ios
}

$(window).bind("orientationchange", function () {
  fireOrientationEvent()
  let deviceHeight = $(window).height()
  let deviceWidth = $(window).width()
  let ios = isIos()
})

$(document).ready(function () {
  let deviceHeight = $(window).height()

  if (!isIos() && deviceHeight && deviceHeight < 650) {
    $(".slideShow").css("height", deviceHeight * 0.6)
  }

  // Collapse search bar on scroll

  document.addEventListener("touchmove", function () {
    if ($("#mobile-search-bar").hasClass("search-bar-open")) {
      toggleSearchBar()
    }
  })

  // Profile slideshow tab toggle
  $(".j-slide-tab").click(function () {
    $(".j-slide-tab-container").hide()
    $(".j-slide-tab").removeClass("selectedTab")
    $(".pagination").hide()
    $(this).addClass("selectedTab")
    $("#" + $(this).attr("id").replace("_button", ""))
      .addClass("selectedTab")
      .show()
  })

  $(".j-toggle-mobile-search").bind("tap, click", function (e) {
    e.stopPropagation()
    toggleSearchBar()
  })

  $("#search_form").submit(function () {
    window._gaq.push(["_trackEvent", "MobileApp", "searchSubmit"])
    window.location = "/search?q=" + $("#q").val()
    return false
  })

  $("#sharebyemail").click(function (e) {
    window._gaq.push(["_trackEvent", "MobileApp", "shareByEmail"])
  })

  $("#j-mobileShare a").on("click", function (e) {
    window._gaq.push(["_trackEvent", "MobileApp", "Clicked_Share"])
  })

  $("#desktop-version").click(function (e) {
    window._gaq.push(["_trackEvent", "MobileApp", "desktopVersionClicked"])
  })

  $("#help").click(function (e) {
    window._gaq.push(["_trackEvent", "MobileApp", "helpButtonClicked"])
  })

  $('a[href="/login"]').attr("href", "/login?from_source=" + encodeURIComponent(window.location.pathname))
  ;(function () {
    let useragent = navigator.userAgent.match(/\([^\)]+\)/)[0]
    let frmPath = window.location.pathname
    $("#mobileFeedback").attr(
      "href",
      "https://slideshare.wufoo.com/forms/m7x2p7/def/field113=" + useragent + "&field115=" + frmPath
    )
  })()

  // Toggle search bar off when they lose focus
  $(document).bind("click", function () {
    // Check if search bar is open and if it is, toggle it closed
    if ($("#mobile-search-bar").hasClass("search-bar-open") && $(".search-field:focus").length === 0) {
      toggleSearchBar()
    }
  })
})

function isSearchBarOpened() {
  return $("#mobile-search-bar").hasClass("open")
}

function toggleSearchBar() {
  let $body = $("body")
  if (isSearchBarOpened()) {
    $("#mobile-search-bar").removeClass("open").find(".search-field").blur()
    $body.removeClass("search-bar-opened")
  } else {
    $("#mobile-search-bar").addClass("open").find(".search-field").focus()
    $body.addClass("search-bar-opened")
  }
}

$(document).ready(function () {
  /* All non-GET requests will add the authenticity token
     if not already present in the data packet */
  window._xhrQ = window._xhrQ || []
  $(document).bind("ajaxSend", function (elm, xhr, s) {
    if (!window._auth_token_name || !window._auth_token) {
      // no csrf protection present.
      // get authenticity token
      if (!window._xhrCSRF) {
        // get the csrf token
        window._xhrCSRF = true
        $.ajax({
          url: "/account/get_form_authenticity_token",
          dataType: "json",
          type: "GET",
          success: function (data) {
            window._auth_token = data.auth_token
            window._auth_token_name = "authenticity_token"
            let i,
              xhrQ = window._xhrQ
            // I would like to use q.unshift, but it doesnt work on IE<=8
            for (i in xhrQ) {
              if (xhrQ.hasOwnProperty(i)) {
                $.ajax(xhrQ[i])
              }
            }
            window._xhrQ = []
          },
        })
      }
      // if post request, then queue
      if (s.type != "GET") {
        window._xhrQ.push(s)
        xhr.abort()
        return false
      }
    }
    if (s.type == "GET") {
      return
    }
    if (s.dataType === "json") {
      return
    }
    if (s.data && s.data.match(new RegExp("\\b" + window._auth_token_name + "="))) {
      return
    }
    if (s.data) {
      s.data = s.data + "&"
    } else {
      s.data = ""
      /* if there was no data, $ didn't set the content-type */
      xhr.setRequestHeader("Content-Type", s.contentType)
    }
    s.data = s.data + encodeURIComponent(window._auth_token_name) + "=" + encodeURIComponent(window._auth_token)
  })

  //mobile profile
  if ($(".userProfile").length) {
    let page = 1
    let $moreBtn = $("#more_button")

    let more_content = function () {
      $.get(location.href + "/more", { more: 1, page_number: page + 1 }, function (data) {
        page++
        $("#slideshow_list_" + (page - 1)).after(data)
        if (page * window.itemsPerPage >= window.totalSlideshows) {
          $moreBtn.hide()
        }
      })
    }

    $moreBtn.click(function () {
      if (page * window.itemsPerPage < window.totalSlideshows) {
        more_content()
      }
    })
  }

  /* Mobile search bar
  ---------------------- */

  $("#j-open-mobile-search").on("click", function (e) {
    e.stopPropagation()
    e.preventDefault()
    toggleSearchBar()
  })

  $("body").on("click", "#main-content-overlay", function (e) {
    e.stopPropagation()
    e.preventDefault()
    if (isSearchBarOpened()) {
      toggleSearchBar()
    }
  })

  let toggleDropdown = function (elem) {
    let dropdownMenu = elem.find(".dropdown-menu")
    let isActive = dropdownMenu.hasClass("open")
    if (isActive) {
      dropdownMenu.hide()
      dropdownMenu.removeClass("open")
    } else {
      dropdownMenu.show()
      dropdownMenu.addClass("open")
    }
  }

  $(".dropdown").on("click", function (e) {
    e.stopPropagation()
    toggleDropdown($(this))
  })

  $("#upload-link").hide()
})
